import Modals from '../../../shared/types/enums/modals';
import TEmpty from '../templates/empty';
import TranslationManager from '../../../shared/assets/locale/translationsManager';

function Exit() {
  return (
    <TEmpty
      message={TranslationManager.get('PAGES.EMPTY.APP_EXIT')}
      modal={Modals.EXIT_APP}
    />
  );
}

export default Exit;
